import { Routes } from "@angular/router";
import { Canvas } from "./components/canvas/canvas";
import { WellsComponent } from "./components/wells/wells.component";

export const routes: Routes = [
  // Empty root - just shows AppComponent toolbar, no child component
  // IVAAP login only fires when user clicks "Wells" button
  { path: "wells", component: WellsComponent },
  { path: "wells/:wellId/canvas", component: Canvas },
];
